import { ISimpleUser } from "../../User/SimpleUserType";

export type IndividualDependentAttrs = {
    _id: string;
    title: string;
    contact: string;
    firstName: string;
    lastName: string;
    relation: string;
    createdBy: string | ISimpleUser;
    modifiedBy?: string | ISimpleUser;
    createdAt: Date;
    updatedAt: Date;
};

export class IndividualDependent {
    public readonly id: string;
    constructor(public attrs: IndividualDependentAttrs) {
        this.id = attrs._id;
    }

    updateDependent(depAttrs: IndividualDependentAttrs) {
        this.attrs = depAttrs;
        return this;
    }

    static fromArray(dependents: IndividualDependentAttrs[]) {
        return dependents.map((t) => new IndividualDependent(t));
    }
}
